import { render, staticRenderFns } from "./writeoffDetail.vue?vue&type=template&id=5d20c2c4"
import script from "./writeoffDetail.vue?vue&type=script&lang=js"
export * from "./writeoffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports